import type {
  ControlNode as ControlNodeType,
  Port,
} from "../../../../util/src/blueprint/types.js";
import { PortHandle } from "../PortHandle.js";
import dico from "../../../../util/src/language/dico.js";
import React from "react";

export interface ControlWaitNodeProps {
  node: ControlNodeType;
  setPortsMap: (
    nodeId: string,
    portId: string,
    element: HTMLElement | null,
  ) => void;
  onPortMouseDown?: (nodeId: string, port: Port) => void;
  onPortMouseUp?: (nodeId: string, port: Port) => void;
  isPortConnected?: (nodeId: string, portId: string) => boolean;
  onPortValueChange?: (nodeId: string, portId: string, value: unknown) => void;
}

const ControlWaitNodeComponent = ({
  node,
  setPortsMap,
  onPortMouseDown,
  onPortMouseUp,
  isPortConnected,
  onPortValueChange,
}: ControlWaitNodeProps) => {
  const behaviorDico = dico().behavior;
  const valuePort = node.ports.find((port) => port.id === "value");
  const delayPort = node.ports.find((port) => port.id === "delayMs");
  const outPort = node.ports.find((port) => port.id === "out");
  if (!valuePort || !delayPort || !outPort) return null;

  return (
    <div
      style={{
        minWidth: 260,
        borderRadius: 8,
        overflow: "hidden",
        background:
          "linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(200, 200, 200, 0.98) 100%)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        border: "1px solid #e5e7eb",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "4px 8px",
          fontSize: 12,
          fontWeight: 700,
          color: "#fff",
          background:
            "linear-gradient(180deg, #93c5fd 0%, #3b82f6 55%, #1d4ed8 100%)",
        }}
      >
        {behaviorDico.controls.wait}
      </div>
      <div style={{ display: "flex", alignItems: "stretch", padding: "6px 0" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            flex: 1,
          }}
        >
          <PortHandle
            node={node}
            port={valuePort}
            setPortsMap={setPortsMap}
            onMouseDown={() => onPortMouseDown?.(node.id, valuePort)}
            onMouseUp={() => onPortMouseUp?.(node.id, valuePort)}
            isConnected={isPortConnected?.(node.id, valuePort.id) ?? false}
          />
          <PortHandle
            node={node}
            port={delayPort}
            setPortsMap={setPortsMap}
            onMouseDown={() => onPortMouseDown?.(node.id, delayPort)}
            onMouseUp={() => onPortMouseUp?.(node.id, delayPort)}
            showValueInput
            onValueChange={(value) =>
              onPortValueChange?.(node.id, delayPort.id, value)
            }
            isConnected={isPortConnected?.(node.id, delayPort.id) ?? false}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            flex: 1,
          }}
        >
          <PortHandle
            node={node}
            port={outPort}
            setPortsMap={setPortsMap}
            onMouseDown={() => onPortMouseDown?.(node.id, outPort)}
            onMouseUp={() => onPortMouseUp?.(node.id, outPort)}
            isConnected={isPortConnected?.(node.id, outPort.id) ?? false}
          />
        </div>
      </div>
    </div>
  );
};

export const ControlWaitNode = React.memo(ControlWaitNodeComponent);
